import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { TenderDocumentsActionTypes } from "./TenderDocuments.type";

export function* fetchAllTenderDocumentss(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/tender-documents?tender_id=${action.payload?.tender_id}`);
    yield put({
      type: TenderDocumentsActionTypes.FETCH_ALL_TENDER_DOCUMENTS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: TenderDocumentsActionTypes.FETCH_ALL_TENDER_DOCUMENTS_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneTenderDocumentss(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/tender-documents/${action.payload}`
    );
    yield put({
      type: TenderDocumentsActionTypes.FETCH_ONE_TENDER_DOCUMENTS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: TenderDocumentsActionTypes.FETCH_ONE_TENDER_DOCUMENTS_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllTenderDocumentss() {
  yield takeLatest(TenderDocumentsActionTypes.FETCH_ALL_TENDER_DOCUMENTS, fetchAllTenderDocumentss);
}

export function* watcherFetchOneTenderDocumentss() {
  yield takeLatest(TenderDocumentsActionTypes.FETCH_ONE_TENDER_DOCUMENTS, fetchOneTenderDocumentss);
}
